export default {
  subtitle: 'Schlüssel authentifizieren Anfragen an die Partner-API. Senden Sie sie im x-api-key-Header.',
  never_used: 'Nie verwendet',
  revoke_confirm: 'Diesen Schlüssel widerrufen? Anfragen damit funktionieren sofort nicht mehr.',
  columns: {
    name: 'Name',
    key: 'Schlüssel',
    status: 'Status',
    last_used_at: 'Zuletzt verwendet',
    created_at: 'Erstellt',
  },
  statuses: {
    active: 'Aktiv',
    revoked: 'Widerrufen',
  },
  buttons: {
    create: 'Schlüssel erstellen',
    revoke: 'Widerrufen',
  },
  toasts: {
    load_error: 'Die API-Schlüssel konnten nicht geladen werden.',
    error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    revoked: 'API-Schlüssel widerrufen.',
  },
};
